export enum PropertyStatusEnum {
    ACTIVE = "Active",
    CLOSED = "Closed",
    INACTIVE = "Inactive",
}
